<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <div class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <ProfileHeader />
      </div>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="grid gap-6 grid-cols-1 xl:grid-cols-3">
      <!-- Left Column -->
      <div class="col-span-1 space-y-6">
        <!-- Connected Accounts Section -->
        <ContentCard title="Connected Accounts">
          <ConnectedAccounts />
        </ContentCard>
      </div>

      <!-- Right Column -->
      <div class="col-span-1 xl:col-span-2 space-y-6">
        <!-- General Information Section -->
        <ContentCard title="General Information">
          <GeneralInformation
            :profile="profile"
            :loading="loadingProfile"
            @update="handleUpdateProfile" />
        </ContentCard>

        <!-- Onboarding Webhooks (admin only) -->
        <ContentCard v-if="profile?.is_admin" title="Onboarding Webhooks">
          <WebhookSettings />
        </ContentCard>
      </div>
    </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { hideLoadingSpinner } from '~/javascript/utils/hide_loader.js'
import { useProfileData } from '~/javascript/composables/use_profile_data'

// Import profile components
import ProfileHeader from './components/profile_header.vue'
import ContentCard from './components/content_card.vue'
import ConnectedAccounts from './components/connected_accounts.vue'
import GeneralInformation from './components/general_information.vue'
import WebhookSettings from './components/webhook_settings.vue'

const {
  profile,
  loadingProfile,
  fetchProfile,
  updateProfile
} = useProfileData()

// Event handlers
const handleUpdateProfile = async(data) => {
  try {
    await updateProfile(data)
    // Handle success notification
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to update profile:', error)
    // Handle error notification
  }
}

// Lifecycle
onMounted(async() => {
  hideLoadingSpinner()

  try {
    await fetchProfile()
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to load profile data:', error)
  }
})
</script>
